// extracted by mini-css-extract-plugin
export default {"BaseGoBack":"BaseGoBack_BaseGoBack__xAF9V","BaseGoBack__icon":"BaseGoBack_BaseGoBack__icon__P6NqE"};